import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { Component, Input } from 'angular-ts-decorators';

import template from './product-comparison-toolbar.component.html';

@Component({
  selector: 'productComparisonToolbar',
  template,
})
export class ProductComparisonToolbarComponent {
  @Input() public products?: IFamily[];
  @Input('@') public toolbarContainer?: string;
}
